window.CanvasUtils ||= {};

window.CanvasUtils.sizeHeight = 18;
window.CanvasUtils.sizeWidth  = 12;
window.CanvasUtils.posterGlobalMultiplier = 1.0;

window.CanvasUtils.loadImage = function (canvas) {
  if (!canvas) return;

  const ctx = canvas.getContext("2d");
  const str = canvas.dataset.coord || "";

  // 🔴 CHANGE #1: CACHE IMAGES PER CANVAS (NO RELOAD ON SCROLL)
  canvas._roomImage   ??= new Image();
  canvas._posterImage ??= new Image();

  const img    = canvas._roomImage;
  const poster = canvas._posterImage;

  img.crossOrigin = "anonymous";
  poster.crossOrigin = "anonymous";

  function draw() {
    if (!img.naturalWidth) return;

    // -------------------------
    // 1) Hi-DPI sizing (STABLE)
    // -------------------------
    const dpr = window.devicePixelRatio || 1;

    const cw = canvas.clientWidth;
    const ch = canvas.clientHeight;

    const w = Math.round(cw * dpr);
    const h = Math.round(ch * dpr);

    // 🔴 CHANGE #2: IGNORE MICRO RESIZES (SCROLL JITTER)
    const EPS = 4;
    if (
      Math.abs(canvas.width  - w) > EPS ||
      Math.abs(canvas.height - h) > EPS
    ) {
      canvas.width  = w;
      canvas.height = h;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }

    ctx.clearRect(0, 0, cw, ch);
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = "high";

    const iw = img.naturalWidth;
    const ih = img.naturalHeight;

    // -------------------------
    // 2) Room background
    // -------------------------
    const baseScale = Math.max(cw / iw, ch / ih);

    const zoomMap = {
      12: 1.60,
      18: 1.60,
      24: 1.10,
      36: 1.05,
    };

    const roomZoom = zoomMap[window.CanvasUtils.sizeWidth] ?? 1.10;
    const scale = baseScale * roomZoom;

    const dw = iw * scale;
    const dh = ih * scale;
    const dx = Math.round((cw - dw) / 2);
    const dy = Math.round((ch - dh) / 2);

    ctx.drawImage(img, dx, dy, dw, dh);


    // -------------------------
    // 3) Coordinates
    // -------------------------
    const coordinates = str
      .split("|")
      .slice(1)
      .map(item => {
        const [key, coords] = item.split("-");
        const [x, y] = coords.split("*");
        return {
          key,
          x: Number(x) * scale,
          y: Number(y) * scale,
        };
      });

    // -------------------------
    // 4) Poster
    // -------------------------
    if (!poster.naturalWidth) return;

    const isVertical = poster.naturalWidth < poster.naturalHeight;

    const posterSizeMap = {
      12: 2.6,
      18: 2.0,
      24: 1.2,
      36: 0.8,
    };

    const sizeMultiplier =
      posterSizeMap[window.CanvasUtils.sizeWidth] ?? 1.0;

    const REF_ZOOM = 1.2;
    const zoomFactor = Math.pow(REF_ZOOM / roomZoom, 1.0);

    let part = (ch / 80) *
      sizeMultiplier *
      zoomFactor *
      (window.CanvasUtils.posterGlobalMultiplier || 1);

    let sw = window.CanvasUtils.sizeWidth;
    let sh = window.CanvasUtils.sizeHeight;

    if (sw > 19 && sw < 36) {
      sw = 19;
      sh = 27;
    }

    const key = window.CanvasUtils.sizeWidth + (cw < 767 ? "m" : "");
    const pos = coordinates.find(o => o.key === key);

    if (!pos) return;

    const drawW = isVertical ? part * sw : part * sh;
    const drawH = isVertical ? part * sh : part * sw;

    const x = dx + pos.x - drawW / 2;
    const y = dy + pos.y - drawH / 2;

    // ===== POSTER LOOK (shadow only, NO white frame) =====
    const base = Math.min(drawW, drawH);

    ctx.save();
    ctx.shadowColor = "rgba(0,0,0,0.28)";
    ctx.shadowBlur = Math.max(12, Math.round(base * 0.04));
    ctx.shadowOffsetX = 0;
    ctx.shadowOffsetY = Math.max(10, Math.round(base * 0.03));
    ctx.drawImage(poster, x, y, drawW, drawH);
    ctx.restore();

    // Crisp redraw (no shadow)
    ctx.drawImage(poster, x, y, drawW, drawH);
    
  }

  // 🔴 CHANGE #3: DRAW ONLY — NO IMAGE RECREATION
  img.onload = draw;
  poster.onload = draw;

  // 🔴 CHANGE #4: SET SRC ONLY IF DIFFERENT
  if (img.src !== canvas.dataset.url) {
    img.src = canvas.dataset.url;
  }

  if (canvas.dataset.poster) {
    if (poster.src !== canvas.dataset.poster) {
      poster.src = canvas.dataset.poster;
    }
  }
};

window.CanvasUtils.resizeCanvasToContainer = function (canvas) {
  const parent = canvas.parentElement;
  if (!parent) return;

  // 🔴 CHANGE #5: NO getBoundingClientRect (SCROLL SAFE)
  const width  = parent.offsetWidth;
  const height = Math.min(parent.offsetHeight, 819);

  canvas.style.width  = width + "px";
  canvas.style.height = height + "px";
  canvas.style.maxHeight = "819px";
};

document.addEventListener("DOMContentLoaded", () => {
  setTimeout(() => {
    document
      .querySelectorAll('canvas[role="room"]')
      .forEach(canvas => {
        window.CanvasUtils.resizeCanvasToContainer(canvas);
        window.CanvasUtils.loadImage(canvas);
      });
  }, 300);
});

window.addEventListener("resize", () => {
  document
    .querySelectorAll('canvas[role="room"]')
    .forEach(canvas => {
      window.CanvasUtils.resizeCanvasToContainer(canvas);
      window.CanvasUtils.loadImage(canvas);
    });
});

window.CanvasUtils.redrawCanvas = function (width, height) {
  window.CanvasUtils.sizeWidth  = width;
  window.CanvasUtils.sizeHeight = height;

  document
    .querySelectorAll('canvas[role="room"]')
    .forEach(canvas => window.CanvasUtils.loadImage(canvas));
};

window.CanvasUtils.updateImage = function (image) {
  document
    .querySelectorAll('canvas[role="room"]')
    .forEach(canvas => {
      canvas.dataset.poster = image;
      window.CanvasUtils.loadImage(canvas);
    });
};
